module.exports = __webpack_public_path__ + "img/callBg.6a92a681.png";